// src/components/products/Benefits.jsx
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

const Benefits = ({ data }) => {

  const { title, benefitsImage, benefitList } = data;
  const [openIdx, setOpenIdx] = useState(0);

  useEffect(() => {
    setOpenIdx(0)
  }, [data])
  
  if (!data || !Array.isArray(data.benefitList) || data.benefitList.length === 0) return null;


  return (
    <Section aria-labelledby="benefits-heading">
      <Container>
        <Header>
          <Title id="benefits-heading">{title ?? "Key Benefits"}</Title>
        </Header>

        <Content>
          <Accordion>
            {benefitList.map((b, idx) => {
              const Icon = b.icon;
              const isOpen = openIdx === idx;
              return (
                <Item key={b.title ?? idx}>
                  <Button
                    onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                    aria-expanded={isOpen}
                  >
                    <Left>
                      {Icon && (
                        <IconBadge aria-hidden="true">
                          <Icon size={18} />
                        </IconBadge>
                      )}
                      <span>{b.title}</span>
                    </Left>
                    <Toggle>{isOpen ? <FaChevronUp /> : <FaChevronDown />}</Toggle>
                  </Button>

                  {isOpen && (
                    <Panel>
                      {Array.isArray(b.points) && (
                        <ul>
                          {b.points.map((pt, i) => (
                            <li key={i}>{pt}</li>
                          ))}
                        </ul>
                      )}
                    </Panel>
                  )}
                </Item>
              );
            })}
          </Accordion>

          {benefitsImage ? (
            <ImageWrap>
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <img src={benefitsImage} aria-label="Benifits Illustration" loading="lazy" />
            </ImageWrap>
          ) : null}
        </Content>
      </Container>
    </Section>
  );
};

export default Benefits;

/* ---------------- styles ---------------- */

const Section = styled.section`
  padding: 64px 20px;
  background: linear-gradient(#232731 10%, #2d2455 100%, #232731 10%);
  color: #fff
`;
const Container = styled.div`
  margin: 0 auto;
  max-width: 1100px;
`;
const Header = styled.div`
  text-align: center;
  margin-bottom: 28px;
`;
const Title = styled.h2`
  font: 700 48px/1.2 Inter, sans-serif;
  letter-spacing: -0.4px;
  margin: 2rem 0 6rem;

  @media (max-width: 991px) {
    font-size: 32px;
    line-height: 1.3;
    margin: 1rem 0 4rem;
  }

  @media (max-width: 640px) {
    font-size: 26px;
    line-height: 1.2;
    margin: 0.1rem 0 3rem;
  }
`;
const Content = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;
const Accordion = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const Item = styled.article`
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff0a;
  overflow: hidden;

  &:focus-within {
    outline: 1px solid #2563eb;
    outline-offset: 2px;
  }
`;
const Button = styled.button`
  width: 100%;
  color: #fff;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  font: 600 15px/1.5 Inter, sans-serif;

  &:focus-visible {
    outline: 1px solid transparent;
    outline-offset: 2px;
    }
`;
const Left = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;
const IconBadge = styled.span`
  display: inline-flex;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
`;
const Toggle = styled.span`
  font-size: 22px;
  line-height: 1;
`;
const Panel = styled.div`
  padding: 0 16px 14px;
  // color: #374151;
  font: 500 14px/1.65 Inter, sans-serif;

  ul {
    margin: 0;
    padding-left: 18px;
    list-style: disc;
  }
`;
const ImageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  border-radius: 16px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    box-shadow: 0 6px 18px rgba(228, 228, 228, 0.12);
    object-fit: cover;
  }
`;
